/** Pointer must stay on the card this long, without scrolling, before the other images are requested. */
export const HOVER_IMAGE_LOAD_DELAY_MS = 400;

const scrollHaltSubscribers = new Set();
let scrollHaltTimer = null;
let isScrollHaltListenerBound = false;

/**
 * Tells hovered cards whether the page is scrolling or has halted.
 * @param {boolean} hasHalted
 */
const notifyScrollHaltSubscribers = (hasHalted) => {
  scrollHaltSubscribers.forEach((subscriber) => subscriber(hasHalted));
};

/**
 * Subscribes a card so large images are not requested while the page is scrolling.
 * One window listener is shared by every product card.
 *
 * @param {(hasHalted: boolean) => void} subscriber
 * @returns {() => void}
 */
export const subscribeToScrollHalt = (subscriber) => {
  if (typeof window !== "undefined" && !isScrollHaltListenerBound) {
    isScrollHaltListenerBound = true;
    window.addEventListener(
      "scroll",
      () => {
        notifyScrollHaltSubscribers(false);
        window.clearTimeout(scrollHaltTimer);
        scrollHaltTimer = window.setTimeout(() => notifyScrollHaltSubscribers(true), HOVER_IMAGE_LOAD_DELAY_MS);
      },
      { passive: true },
    );
  }

  scrollHaltSubscribers.add(subscriber);
  return () => {
    scrollHaltSubscribers.delete(subscriber);
  };
};
